import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
export default function Rescheduled(props) {
    const navigate = useNavigate();
    const { t } = useI18N();
    const goTo = (e) => {
        let target = e.target.closest('button');
        if (!target) {
            target = e.target.closest('li');
        }
        let path = target.getAttribute('rel');
        navigate(`/${path}`);
    };
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { variant: "h6", children: t('Je afspraak is verzet.') }), _jsx(Alert, { severity: "success", variant: "outlined", sx: { my: 2 }, children: "Donderdag 22 mei, 19:30, Kick-boxen, Zaal 1" }), _jsx(Button, { onClick: goTo, rel: 'oa_widget_appointments', fullWidth: true, variant: "contained", children: t('Terug naar afspraken') })] }));
}
